import { PencilSimple, TrashSimple } from '@phosphor-icons/react'
import { Button, Popconfirm } from 'antd'

import { CompletePageConditionalRuleResponse } from '@/domain/model/forms'
import { useUpdateURLSearchParams } from '@/hooks/useQuery'
import Tooltip from '@/ui/atoms/Tooltip'

type Props = {
  conditionalRuleData: CompletePageConditionalRuleResponse[] | undefined
  confirmDeleteById: (id: string, is_new?: boolean) => Promise<void>
}

export const CollapseConditionalRule = ({
  conditionalRuleData,
  confirmDeleteById,
}: Props) => {
  const updateParams = useUpdateURLSearchParams()

  const handleStopPropagation = (e?: React.MouseEvent<HTMLElement>) => {
    if (e && e.stopPropagation) {
      e.stopPropagation()
    }
  }

  return (
    <div className="flex w-full flex-col gap-3">
      {conditionalRuleData?.map((item, index) => (
        <div
          className="flex cursor-pointer items-center justify-between rounded-[10px] border bg-white px-3 py-2 !outline-none hover:!bg-white/60"
          key={item.id}
          onClick={() => updateParams(['edit_condition_settings', item.id])}
        >
          <span className="font-bold text-gray-800">Rule {index + 1}</span>
          <div className="flex h-full items-center justify-center">
            <Tooltip mouseEnterDelay={0.4} title="Edit rule">
              <Button
                className="!px-2 !text-gray-600 !outline-none hover:!text-primary"
                onClick={(event) => {
                  event.stopPropagation()
                  event.preventDefault()
                  updateParams(['edit_condition_settings', item.id])
                }}
                type="link"
              >
                <PencilSimple />
              </Button>
            </Tooltip>
            <Tooltip mouseEnterDelay={0.4} title="Delete rule">
              <Popconfirm
                cancelButtonProps={{
                  style: { zoom: 0.75 },
                }}
                classNames={{ body: '[&_.ant-btn]:!py-3.5' }}
                description="Are you sure you want to delete this rule?"
                icon={false}
                okButtonProps={{ style: { zoom: 0.75 } }}
                onCancel={handleStopPropagation}
                onConfirm={async (event) => {
                  handleStopPropagation(event)
                  await confirmDeleteById(item.id, item.is_new)
                }}
                title={undefined}
              >
                <Button
                  className="!px-2 !text-gray-600 !outline-none hover:!text-red-700"
                  onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                  }}
                  type="link"
                >
                  <TrashSimple />
                </Button>
              </Popconfirm>
            </Tooltip>
          </div>
        </div>
      ))}
    </div>
  )
}
